import { Modal } from '@/components/ui/Modal';

import { LegalDocArticle } from './LegalDocArticle';
import { getLegalDoc, type LegalDocId } from './legalContent';
import styles from './LegalDocModal.module.css';

/**
 * Sign-in screen viewer for the legal documents in docs/legal/ (PLA-1091).
 * Reuses the shared Modal (Escape, scroll lock, full-screen sheet with
 * swipe-to-close on mobile) so it matches every other modal in the app.
 */
interface LegalDocModalProps {
  /** Which document to show; null renders nothing. */
  docId: LegalDocId | null;
  onClose: () => void;
}

export function LegalDocModal({ docId, onClose }: LegalDocModalProps) {
  const doc = docId ? getLegalDoc(docId) : null;

  return (
    <Modal
      open={doc != null}
      onClose={onClose}
      labelledBy="legal-doc-title"
      fullScreenOnMobile
      title={
        doc ? (
          <h2 id="legal-doc-title" className={styles.title}>
            {doc.title}
          </h2>
        ) : null
      }
      subtitle={doc?.subtitle}
    >
      {doc && <LegalDocArticle doc={doc} />}
    </Modal>
  );
}
